import { createSlice } from '@reduxjs/toolkit';
import keyBy from 'lodash/keyBy';

const transformMealsResponse = response => keyBy(response.mealSelections, 'id');

const mealsSlice = createSlice({
  name: 'meals',
  initialState: {},
  reducers: {},
  extraReducers: builder => {
    builder.addCase('GET_MEALS_RESPONSE', (state, action) => {
      return {
        ...state,
        ...transformMealsResponse(action.response),
      };
    });
  },
  selectors: {
    selectMeal: (sliceState, id) => sliceState[id],
  },
});

export default mealsSlice;
